import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import OSGStatementsPage, { getDefaultData } from "components/pages/OSGStatementsPage";
import Classes, { Account, Document } from "model";

export default function CaptureOSGStatementsChecking(props) {
    const context = useBCMSContext();

    BCMSRecord.globalControllerFor(Classes, context);

    const selectedAccount = Account.initAll()[0].id;
    const documents = Document.sortDateAscending(Document.initAll()).filter(item => {
        return item.account.id === selectedAccount;
    }, []);

    const data = BCMSStateManagerCRUD.init(getDefaultData())
        .update([ "search", "account" ], selectedAccount)
        .update([ "search", "filtered" ], documents)
        .submit();

    return <OSGStatementsPage data={ data } />
}